<script>
import { mapActions } from 'vuex'
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'

export default {
  components: {
    AppModal,
    AppLabel
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      email: '',
      isCamposModal: true,
      cpfCnpj: '',
      emailBuscado: ''
    }
  },

  methods: {
    ...mapActions({
      findEmailByCpfCnpj: 'usuario/findEmailByCpfCnpj',
      requestRedefinirSenha: 'usuario/requestRedefinirSenha'
    }),

    closeModal () {
      this.$emit('closeModal')
    },

    async buscarEmail () {
      if (!(await this.$refs.observer.validate())) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
        )
      } else {
        const result = await this.findEmailByCpfCnpj(this.cpfCnpj)

        this.isCamposModal = false
        this.emailBuscado = result
      }
    },

    async redefinirSenha () {
      if (!(await this.$refs.observer.validate())) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
        )
        return
      }

      await this.requestRedefinirSenha({
        cpfCnpj: this.cpfCnpj,
        email: this.email}
      )

      this.showNotificacao(
        this.$messages.TIPO_SUCCESS,
        this.$messages.TITULO_SUCCESS,
        this.$messages.MSG_REDEFINIR_SENHA
      )
      this.closeModal()
    }

  }

}
</script>

<template>
  <app-modal
    titulo="Redefinir senha"
    :width="600"
    @closeModal="closeModal()"
  >
    <template slot="body">
      <validation-observer ref="observer" tag="form">
        <div v-if="isCamposModal" :key="'cpfCnpj'">
          <app-label label="Insira seu CPF/CNPJ" />
          <form @keyup.enter="getErro()">
            <validation-provider
              rules="required|cpf_cnpj"
              v-slot="{ errors }"
              name="cpfCnpj"
              mode="lazy"
            >
              <el-input
                class="input"
                :class="{ erro: errors.length }"
                v-model="cpfCnpj"
                v-mask="['###.###.###-##', '##.###.###/####-##']"
              />
              <span class="help erro">{{ errors[0] }}</span>
            </validation-provider>
          </form>
        </div>

        <div v-else :key="'email'">
          <app-label label="Insira seu e-mail" />
          <form @keyup.enter="getErro()">
            <validation-provider
              rules="required|email"
              v-slot="{ errors }"
              name="email"
              mode="lazy"
            >
              <el-input
                class="input"
                :class="{ erro: errors.length }"
                v-model="email"
              />
              <span class="help erro">{{ errors[0] }}</span>
            </validation-provider>
          </form>
          <p class="margin-top">Email cadastrado: {{ this.emailBuscado }}</p>
        </div>
      </validation-observer>
    </template>

    <template slot="footer">
      <div class="buttons">
        <el-button @click="closeModal()">Cancelar</el-button>
        <el-button
          v-if="isCamposModal"
          @click="buscarEmail()"
          :key="'botao-proximo'"
        >
          Próximo
        </el-button>
        <el-button
          v-else
          @click="redefinirSenha()"
          :key="'botao-confirma'"
        >
          Confirmar
        </el-button>
      </div>
    </template>
  </app-modal>
</template>

<style scoped lang="scss">
.buttons {
  display: flex;
  justify-content: space-between;
}

.margin-top {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components(new)/security/RedefinirSenha.vue